module.exports = __webpack_public_path__ + "img/icon_Government.50ac2308.svg";